import styled from "styled-components";

export const TableContainer = styled.table`
  width: 50%;
  border-collapse: collapse;
  border-radius: 0.25rem;
  background: #fff;
  box-shadow: 0px 3px 12px -3px rgba(0, 0, 0, 0.5);

  @media (max-width: 1420px) {
    width: 90%;
  }

  @media (max-width: 480px) {
    width: 98%;
  }
`;

export const TableHead = styled.thead`
  background: var(--red-color);
  color: #e6e7e9;
  text-transform: uppercase;

  th {
    padding: 1rem 0;
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const TableBody = styled.tbody`
  text-align: center;

  tr {
    border-bottom: 1px solid #f4f4f4;
    cursor: pointer;
    will-change: transform;
    transition: all 0.3s linear;

    @media screen and (max-width: 768px) {
      border-bottom: 1px solid #d1d1d1;
    }

    td {
      padding: 1rem 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:disabled {
        cursor: not-allowed;
      }

      @media screen and (max-width: 768px) {
        font-weight: lighter;
        display: block;
        width: 100%;
        text-align: right;
        padding-right: 3%;
        position: relative;

        &:before {
          content: attr(data-title);
          position: absolute;
          left: 0;
          width: 6%;
          padding-left: 15px;
          font-size: 15px;
          font-weight: bold;
          text-transform: uppercase;
        }
      }
    }

    &:hover {
      filter: brightness(90%);
      box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
      transform: translateY(-1px);
      background: #e6e7e9;
    }
  }
`;
